export default "__VITE_ASSET__CEsu0VIA__"